import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/NotFound.css';
import logo from '../assets/zwyk-logo-white3.svg';

const NotFound: React.FC = () => {
  return (
    <div className="not-found">
      <div className="not-found-content">
        <img className="not-found-logo" width={120} height={'auto'} src={logo} alt="Zwyk Logo" />
        <h1 className="not-found-code">
          4<span className="zwyk-color">0</span>4
        </h1>
        <h2 className="not-found-title">Zabłądziłeś na szlaku</h2>
        <p className="not-found-subtitle">
          Tej strony tu nie ma. Wróćmy na pewną ścieżkę.
        </p>
        <Link to="/" className="button not-found-button">
          Wróć na stronę główną
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
